import { render, staticRenderFns } from "./GraficoPonteiroDRE.vue?vue&type=template&id=653f39e0"
import script from "./GraficoPonteiroDRE.vue?vue&type=script&lang=js"
export * from "./GraficoPonteiroDRE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports